
// export default API;

import axios from "axios";
//https://shehabcorp.com/api http://localhost/php-backend/api
const API_BASE_URL = 'https://shehabcorp.com/api';
export const fetchProducts = async ({ category, subcategory, subsubcategory }) => {
  try {
    const url = new URL(`${API_BASE_URL}/products.php`);
    
    if (category) url.searchParams.append("category", category);
    if (subcategory) url.searchParams.append("subcategory", subcategory);
    if (subsubcategory) url.searchParams.append("subsubcategory", subsubcategory);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Failed to fetch products");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};


export const fetchJobs = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/careers.php`);
    return data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    return []; // Returns an empty array in case of error
  }
};

export const fetchClients = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/clients.php`);
    return data;
  } catch (error) {
    console.error("Error fetching clients:", error.message);
    return []; // Returns an empty array in case of error
  }
};
